import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'

interface LoadingIndicatorProps {
  open: boolean
}

export default function LoadingIndicator({ open }: LoadingIndicatorProps): JSX.Element {
  return (
    <Backdrop sx={{ color: '#fff', zIndex: 3000 }} open={open}>
      <CircularProgress color="inherit" data-testid="loader" />
    </Backdrop>
  )
}
